
const nss_scrolling_5050 = {
    init: () => {
        const nssScrolling5050s = document.querySelectorAll('[nss-scrolling-5050]');

        [...nssScrolling5050s].forEach(nssScrolling5050 => {
            const videoTriggers = nssScrolling5050.querySelectorAll('[nss-scrolling-5050-video-trigger]');

            [...videoTriggers].forEach(videoTrigger => {
                videoTrigger.addEventListener('click', () => {
                    const videoWrapper = videoTrigger.closest('[nss-scrolling-5050-video-wrapper]');
                    if (videoWrapper) {
                        const videoEl = videoWrapper.querySelector('video');
                        if (videoEl) {
                            videoWrapper.classList.add('video--playing');
                            videoEl.controls = true;
                            videoEl.play();
                        }
                    }
                });
            })
        });
    }
}

export default nss_scrolling_5050;
